import React, { useState, useEffect, useRef } from 'react';
import { Check, Zap, Clock, BookOpen, Target, Gift, Sun, Moon, Terminal, RotateCw } from 'lucide-react';

const MissionCard = ({ mission, darkMode, index }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  const Icon = {
    Zap: Zap,
    Clock: Clock,
    BookOpen: BookOpen,
    Target: Target,
    Sun: Sun,
    Moon: Moon,
    Terminal: Terminal,
    RotateCw: RotateCw
  }[mission.icon] || Zap;

  return (
    <div ref={ref} className="widget-card" style={{
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      marginBottom: '15px',
      padding: '20px',
      backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.05)' : 'rgba(255, 255, 255, 0.03)',
      backdropFilter: 'blur(5px)',
      WebkitBackdropFilter: 'blur(5px)',
      border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
      borderRadius: '16px',
      opacity: isVisible ? 1 : 0,
      animation: isVisible ? `pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${index * 0.1}s both` : 'none'
    }}>
      <div style={{ width: '50px', display: 'flex', justifyContent: 'center' }}>
        <Icon size={32} color={mission.completed ? '#58cc02' : (darkMode ? '#fff' : '#4b4b4b')} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: '700', fontSize: '1rem', color: darkMode ? '#e5e5e5' : '#4b4b4b', marginBottom: '8px' }}>
          {mission.description}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ flex: 1, height: '16px', backgroundColor: darkMode ? '#333' : '#e5e5e5', borderRadius: '8px', overflow: 'hidden', position: 'relative' }}>
            <div style={{ 
              width: `${Math.min(100, (mission.progress / mission.target) * 100)}%`, 
              height: '100%', 
              backgroundColor: mission.completed ? '#58cc02' : '#ffc800', 
              position: 'absolute', 
              top: 0, 
              left: 0,
              transition: 'width 0.5s ease'
            }}></div>
            <div style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', fontWeight: '700', color: mission.completed ? '#fff' : (darkMode ? '#fff' : '#4b4b4b'), zIndex: 1 }}>
              {mission.progress} / {mission.target}
            </div>
          </div>
          {mission.completed ? (
             <Check size={24} color="#58cc02" strokeWidth={4} />
          ) : (
             <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#afafaf', fontSize: '0.9rem', fontWeight: 'bold' }}>
                <Gift size={16} /> 100
             </div>
          )}
        </div>
      </div>
    </div>
  );
};

function Missions({ dailyMissions, darkMode }) {
  return (
    <main className="main-content" style={{ height: '100vh', overflowY: 'auto', paddingBottom: '40px' }}>
      <style>{`
        @keyframes pop-up {
          0% { transform: scale(0.95); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
      <div className="main-content-header" style={{ position: 'sticky', top: '20px', zIndex: 10, backgroundColor: '#1cb0f6', borderBottom: '4px solid #148ac2', borderRadius: '16px', color: 'white', marginBottom: '20px', marginTop: '20px' }}>
        <h2>Missionen</h2>
        <span>Tagesziele</span>
      </div>
      
      <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto', padding: '0 20px', boxSizing: 'border-box' }}>
        {dailyMissions.map((mission, index) => (
            <MissionCard key={index} mission={mission} darkMode={darkMode} index={index} />
        ))}
      </div>
    </main>
  );
}

export default Missions;
